import React from 'react';
import { TextField } from '@mui/material';
import { reusableTextFieldStyles } from './ReusableTextField.styles';

const ReusableTextField = ({ 
  label, 
  value, 
  onChange, 
  multiline = false, 
  rows = 1,
  fullWidth = true,
  textColor = '#1F1F1F',
  error = false,
  helperText,
  ...other 
}) => {
  return (
    <TextField
      fullWidth={fullWidth}
      label={label}
      variant="outlined"
      value={value}
      onChange={onChange}
      multiline={multiline}
      rows={rows}
      error={error}
      helperText={helperText}
      sx={reusableTextFieldStyles(textColor, error)}
      {...other}
    />
  );
};

export default ReusableTextField;

